import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function SoloAgentsSection() {
    return (
        <section className="bg-white py-24 md:py-32" id="solo-agents" data-testid="solo-agents-section">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <p className="text-gold-400 text-xs font-bold tracking-[0.25em] uppercase font-inter mb-4">The Solo Agent</p>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight mb-6">
                        You're Proof That Hard Work Works. It's Also Killing You.
                    </h2>
                    <div className="space-y-6 text-[#6B7280] text-lg leading-relaxed">
                        <p>You built a real business. You generate leads, close deals, and keep clients happy - often at a level that puts you in the top 5% of agents in your market. But you're also answering your own emails, doing your own follow-up, managing your own calendar, and working most Sundays.</p>
                        <p>You've told yourself your clients need you specifically. That your touch is what keeps them loyal. That nobody else can do it right.</p>
                        <p>Maybe you tried a local assistant. Expensive and underutilized. Maybe you tried a VA. It didn't stick - and now part of you has decided that delegation just doesn't work for someone like you.</p>
                        <p>Here's the truth: you didn't fail at delegation. The process failed you. Rushed hiring, no role clarity, no onboarding, no oversight. That's not a people problem. That's a systems problem.</p>
                        <p>What you actually need is a seasoned VA, a defined role, and a management system that runs without you babysitting it. The result isn't just more time - it's a business that can grow without you carrying every pound of it yourself.</p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
